(function ($) {
  'use strict';

  /**
   * External Links
   * ---
   * - Adds aria-label indication for new tab
   * - Adds 'nofollow noopener' for extra security
   * - Adds icon (ignores links styled as buttons)
   */

  // Apply only to navigation links
  var $parents = $( '.navigation--utility, .navigation--footer, navigation--footer-privacy, .navigation--mobile-utility' );
  // Ignore anchor & relative links
  var $external_links = $parents.find( 'a[href]:not( [href^="#"], [href^="/"], .no-external-icon )' );

  $external_links.each(function () {
    // Skip links that are _not_ external
    if ( ! is_url_external( $(this).attr( 'href' ) ) ) {
      return true;
    }

    var $this = $(this);
    var aria_label = $this.attr( 'aria-label' );
    var link_text = $this.text();
    var a11y_text = link_text + ' (opens in a new tab)';

    // Add nofollow
    $this.attr( 'rel', 'nofollow noopener' );

    // Add aria-label
    // - Ignore links that already have an aria-label set
    if ( ! aria_label ) {
      $this.attr( 'aria-label', a11y_text );
    }

    // Add new tab icon
    // - Ignore links styled as buttons
    if ( ! $this.is( '.button, .button-outline, .text-button, .wp-element-button, .wp-block-button__link, .social-nav-link, .menu-item-button > a' ) ) {
      $this.addClass( 'has-new-tab-icon' );
    }
  });

  // Validate External Link
  function is_url_external( url ) {
    var tmp_link = document.createElement( 'a' );
    tmp_link.href = url;
    return tmp_link.host !== window.location.host;
  }

})(jQuery);
